// removed by extract-text-webpack-plugin
module.exports = {"wasabi-slidepanel":"wasabi-slidepanel","slide-overlay":"slide-overlay","slide-container":"slide-container","slide-header":"slide-header","title":"title","close":"close","slide-body":"slide-body","slide-footer":"slide-footer","slide-toolbar":"slide-toolbar","slide-close":"slide-close"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Layout/SlidePanel.scss
// module id = 251
// module chunks = 0